// Firebase configuration
import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  onAuthStateChanged,
  User,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Firebase configuration (client-side keys are intentionally public)
const firebaseConfig = {
  apiKey: "AIzaSyB1tfthc-YL_V854e7YS-HCBJXOlq_rEgQ",
  authDomain: "cowrite-6daa3.firebaseapp.com",
  projectId: "cowrite-6daa3",
  storageBucket: "cowrite-6daa3.firebasestorage.app",
  messagingSenderId: "39705192469",
  appId: "1:39705192469:web:2eefd2205cbd557d68461c",
  measurementId: "G-94K28JCTZC",
};

// Initialize Firebase safely
// Note: Ensure REACT_APP_FIREBASE_* variables are set in your hosting provider's dashboard
let app: any;
let auth: any = null;
let db: any = null;

const isConfigured = !!firebaseConfig.apiKey;

try {
  if (isConfigured) {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app);
  } else {
    console.warn("Firebase API Key missing. Auth and DB will be unavailable.");
  }
} catch (error) {
  console.error("Firebase initialization failed:", error);
}

export { auth, db };

// Helper to ensure auth is available before calling methods
const ensureAuth = () => {
  if (!auth) {
    throw new Error(
      "Firebase Auth is not initialized. Please check your environment variables (REACT_APP_FIREBASE_API_KEY).",
    );
  }
  return auth;
};

// Google Auth Provider — always prompt account selector
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

// Sign in with Google
export const signInWithGoogle = async () => {
  try {
    const firebaseAuth = ensureAuth();
    const result = await signInWithPopup(firebaseAuth, googleProvider);
    return result.user;
  } catch (error: any) {
    console.error("Error signing in with Google:", error);
    throw error;
  }
};

// Sign in with Email and Password
export const signInWithEmail = async (email: string, pass: string) => {
  try {
    const firebaseAuth = ensureAuth();
    const result = await signInWithEmailAndPassword(firebaseAuth, email, pass);
    return result.user;
  } catch (error: any) {
    console.error("Error signing in with email:", error);
    throw error;
  }
};

// Create Account with Email and Password
export const signUpWithEmail = async (email: string, pass: string) => {
  try {
    const firebaseAuth = ensureAuth();
    const result = await createUserWithEmailAndPassword(
      firebaseAuth,
      email,
      pass,
    );
    return result.user;
  } catch (error: any) {
    console.error("Error signing up with email:", error);
    throw error;
  }
};

// Sign out
export const logOut = async () => {
  try {
    const firebaseAuth = ensureAuth();
    await signOut(firebaseAuth);
  } catch (error: any) {
    console.error("Error signing out:", error);
    throw error;
  }
};

// Auth state observer
export const onAuthChange = (callback: (user: User | null) => void) => {
  if (auth) {
    return onAuthStateChanged(auth, callback);
  }
  // Fallback if not configured
  console.log("onAuthChange: Firebase not configured, calling fallback.");
  callback(null);
  return () => {};
};

export default app;
